import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { CMS } from '../../utils/CMS';

export const PrimeBanner = ({ tabType }) => {
    const [isGV, setisGV] = useState(false);
    useEffect(() => {
        window.Odigeo && window.Odigeo.SessionScope && window.Odigeo.SessionScope.brand === 'GV' && setisGV(true);
    }, []);
    const textKey = `prime.home.${tabType}.banner.message`;
    return (
        <div className="odf-calendar-day-range odf-message-inline odf-space-inner-m">
            <div style={{ paddingTop: isGV && 'unset' }} className="odf-message-icon odf-space-inner-top-s odf-space-inner-right-s">
                <span className="odf-logo-prime odf-logo-prime-xs" />
            </div>
            <div className="odf-message-content">
                <div className="odf-flex-container-row odf-flex-container-nogutter">
                    <div className="odf-flex-item odf-text-md odf-text-mono-color-02">
                        <CMS
                            id={textKey}
                            dangerouslySetInnerHTML
                        />
                    </div>
                    <div className="odf-flex-item odf-text-right">
                        <span id="primeBannerInitSessionLink" className="odf-strong odf-link hotels_banner_login shell-integration_portal" />
                    </div>
                </div>
            </div>
        </div>
    );
};

PrimeBanner.propTypes = {
    tabType: PropTypes.string
};
